export const PAYSCHEDULE_EDITABLE_PARAM = "isProcessed";
export enum PAYSCHEDULE_URLS {
  Detail = "/payschedule/<%id%>?companyid=<%companyId%>&businessunitid=<%businessUnitID%>",
}
